import { DEFAULT_THEME_ACCENT, normalizeAccentColor } from "@/lib/theme/constants";
import { useThemeStore, type ThemeMode } from "@/store/theme-store";

export type UserThemePreferences = {
  theme_mode?: ThemeMode | null;
  theme_accent?: string | null;
};

export function applyStoredThemePreferences(preferences?: UserThemePreferences | null) {
  if (!preferences) return;
  const { setTheme, setAccentColor } = useThemeStore.getState();
  if (preferences.theme_mode === "light" || preferences.theme_mode === "dark") {
    setTheme(preferences.theme_mode);
  }
  const accent = normalizeAccentColor(preferences.theme_accent) ?? DEFAULT_THEME_ACCENT;
  setAccentColor(accent);
}
